import { render, staticRenderFns } from "./BlankItemSkeleton.vue?vue&type=template&id=9dac1a2c&scoped=true&lang=pug&functional=true&"
import script from "./BlankItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./BlankItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BlankItemSkeleton.vue?vue&type=style&index=0&id=9dac1a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "9dac1a2c",
  null
  
)

export default component.exports